import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const AnnualPopupMessageIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros específica para SubSectionKPI
    const filterConfig = useMemo(() => [        
        {
            type: "text",
            name: "title",
            label: "Title",
            placeholder: "Title..."
        },
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
            sortable: true 
        },
        { 
            title: 'Display Start Date', 
            dataIndex: 'displayStartDate', 
            key: 'displayStartDate', 
            sortable: true 
        },
        { 
            title: 'Display End Date', 
            dataIndex: 'displayEndDate', 
            key: 'displayEndDate', 
            sortable: true 
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 80,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/annualPopupMessage/edit/${record.annualPopupMessageID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Annual Popup Message"
            apiEndpoint="/annualPopupMessage/getAllPaginated"
            toggleActiveEndpoint="/annualPopupMessage/toggleActive"
            toggleDeletedEndpoint="/annualPopupMessage/toggleDeleted"
            newRoute="/annualPopupMessage/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="annualPopupMessageID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default AnnualPopupMessageIndex;
